import type React from "react";
import { EmailRepliesPage } from "routes/emails/EmailRepliesPage/EmailRepliesPage";

/**
 * 返信管理ページ (Phase 3 第2層)
 * @return {React.ReactElement} 返信管理画面
 */
const EmailRepliesPageContainer: React.FC = () => {
  return <EmailRepliesPage />;
};

export default EmailRepliesPageContainer;
